<ng-container *ngIf="portalId">
    <iframe
        [src]="iFrameData$ | async | safeUrl"
        scrolling="no"
        sandbox="allow-same-origin allow-scripts allow-downloads allow-popups allow-forms allow-popups-to-escape-sandbox"
        #iFrameSection
    ></iframe>
</ng-container>
